import './polyfils';

import * as React from 'react';
import { render } from 'react-dom';

import App from './app/App';

const root = document.querySelector('#root');
render(<App />, root);
